import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../../services/ApiService'
import { confirmationAlert, showAlert } from '../../../../utility/SweetAlert'

const InteractorMasterMenuTeamDelete = () => {
  const { t } = useTranslation()
  const masterMenuDelete = useCallback(
    (body, loading) => {
      const { uid, updated_by, menu_name } = body
      const payload = {
        uid,
        updated_by,
      }
      confirmationAlert({
        message: `${t('message.confirm_delete')} ${menu_name} ?`,
        icon: 'question',
      }).then(result => {
        if (result === true) {
          ApiService.jsonRequest('/master-menu/team-delete', payload, response => {
            loading(false)
            if (response.status_code === 200) {
              showAlert({
                icon: 'success',
                message: t('message.successfully_deleted'),
                timer: 1500,
                redirect: '/master/menu-team/manage',
              })
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 1500,
              })
            }
          })
        } else {
          loading(false)
        }
      })
    },
    [t],
  )
  return { masterMenuDelete }
}

export default InteractorMasterMenuTeamDelete
